module.exports = __webpack_public_path__ + "static/img/Minspend.e1a9b80.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/business/Minspend.png
// module id = s1iJ
// module chunks = 45